export const DealType = {
    "Guaranteed": {
        "description": "Guaranteed",
        "id": 2
    },
    "UnreservedFixed": {
        "description": "Unreserved Fixed",
        "id": 4
    },
    "PrivateAuction": {
        "description": "Private Auction",
        "id": 5
    }
};
